
module.exports = function()
{
    this.keyboardType = null;
    this.onKeyDown = null;
    this.onEnter = null;
    this.onBackspace = null;
}